




















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Translation from '@/components/i18n/Translation.vue';
import TranslationSource from '@/types/i18n/TranslationSource';
import FormField from '@/components/form/FormField.vue';
import { ValidationError } from 'class-validator';

@Component({
  components: { Translation, FormField },
})
export default class CheckboxField extends Vue {
  @Prop(Boolean)
  public disabled!: boolean;

  @Prop(Boolean)
  public value!: boolean;

  @Prop({ type: Boolean, default: true })
  public labelIsPath!: boolean;

  @Prop(String)
  public identifier!: string;

  @Prop(String)
  public label!: string;

  @Prop(Boolean)
  public hasInfo!: boolean;

  @Prop(Array)
  public options!: Array<{ value: string | number; label: string | number }>;

  @Prop(Object)
  public validationError!: ValidationError | null;

  @Emit()
  public infoClick(): void {}

  public onInput() {
    this.$emit('input', !this.value);
    this.$emit('click');
  }
}
